import { Chess } from "chess.js";

const GLYPH: Record<string, string> = { k: "♚", q: "♛", r: "♜", b: "♝", n: "♞", p: "♟" };

/** A static SVG board for thumbnails. Renders on the server, no JavaScript. */
export function MiniBoard({ fen, className = "" }: { fen: string; className?: string }) {
  const board = new Chess(fen).board();
  return (
    <svg viewBox="0 0 8 8" className={className} role="img" aria-label="Board position" shapeRendering="crispEdges">
      {board.map((row, r) =>
        row.map((sq, f) => (
          <g key={`${r}${f}`}>
            <rect x={f} y={r} width={1} height={1} fill={(r + f) % 2 === 0 ? "#ecdcbc" : "#b58863"} />
            {sq && (
              <text
                x={f + 0.5}
                y={r + 0.8}
                fontSize={0.82}
                textAnchor="middle"
                fill={sq.color === "w" ? "#fbf7ef" : "#231d17"}
                stroke={sq.color === "w" ? "#2a241d" : "none"}
                strokeWidth={0.04}
                paintOrder="stroke"
                className="piece-glyph"
                shapeRendering="geometricPrecision"
              >
                {GLYPH[sq.type] + "︎"}
              </text>
            )}
          </g>
        )),
      )}
    </svg>
  );
}
